const { gql } = require('@apollo/client');

const deps = ['Collection', 'Country'];

const factory = function (Collection, Country) {
  class CountryCollection extends Collection {
    $init() {
      super.$init();
      this.regions = []; // flattened regions from all countries
      return this.$fetch();
    }

    $fetch() {
      const query = gql`
        query Countries {
          countries {
            id
            name
            code
            currency {
              id
              code
              name
            }
            regions {
              countryCode
              code
              name
              taxPercent
            }
          }
        }
      `;
      const fetchPolicy = 'no-cache';
      return this.$graphqlClient
        .queryV2({ query, fetchPolicy })
        .then(res => {
          const countries = res.data.countries.map(country => ({
            ...country,
            // Map currency object to currencyId for backwards compatibility
            currencyId: country.currency?.id,
          }));
          this.$set(countries, { reset: true });

          // Flatten regions from all countries for backwards compatibility
          this.regions = res.data.countries.flatMap(country =>
            (country.regions || []).map(region => ({
              ...region,
              // Map 'code' to 'regionCode' for backwards compatibility
              regionCode: region.code,
            })),
          );

          return this.$cache();
        })
        .catch(() => {});
    }

    // Helper to get regions for a specific country
    getRegionsByCountryCode(countryCode) {
      return this.regions.filter(region => region.countryCode === countryCode);
    }
  }

  CountryCollection.prototype.$resource = 'country';
  CountryCollection.prototype.$id = 'single';
  CountryCollection.prototype.$type = Country;

  return CountryCollection;
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name, require('data/model/country').name];

module.exports = angular
  .module('bench.data.collection.country', moduleDeps)
  .factory('CountryCollection', factory);
